// The pulsing star ("do this next"): a small circle with a star that pulses on
// a corner of whatever needs the installer's attention: the next field in the
// new-widget wizard, or the Save button when a tab has unsaved changes.
// Place it inside a position: relative parent; it never blocks clicks.
import { Star } from "lucide-react";

// corner: on the top-right / top-left corner of its parent, or "inline" to sit in the
// line of text (e.g. at the end of a checkbox label, clear of the checkbox)
export function Attention({ corner = "tr", label = "Do this next" }: { corner?: "tr" | "tl" | "inline"; label?: string }) {
  return (
    <span className={`attention attention-${corner}`} role="img" aria-label={label} title={label}>
      <Star size={12} fill="currentColor" aria-hidden="true" />
    </span>
  );
}
